import { THROTTLING } from "../const.js";
import { JamHandlerType } from "../types.js";

export function debounce<
  Args extends unknown[],
  Func extends (...args: Args) => unknown
>(
  func?: JamHandlerType<Args>,
  waitFor = THROTTLING
): JamHandlerType<Args, ReturnType<Func>> {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  const debounced = (...args: Args) => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => func && func(...args), waitFor);
  };

  debounced.hasCallback = !func ? false : func.hasCallback ?? true;

  return debounced as JamHandlerType<Args, ReturnType<Func>>;
}
